<template>
  <cv-tile>
    <slot />
  </cv-tile>
</template>
